import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MenuItem } from "@material-ui/core";
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';

export const CboLocalidades = React.memo((props) => {
  const [listaLoc, setListaLoc] = useState([]);
  const { items } = useSelector((state) => state.localidades);

  useEffect(() => {
    if (items?.length > 0) {
      const listaFiltrada = items.filter(
        (loc) => props.cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(props.cp)
      );
      let locsFromState = listaFiltrada.map((loc) => {
        return {
          value: loc.id_localidad,
          display: loc.descripcion_localidad,
        };
      });
      setListaLoc(locsFromState);
    }
  }, [items, props.cp]);

  useEffect(() => {
    if (items?.length > 0) {
      ValidatorForm.addValidationRule('existCP', (value) => {
        if (items.filter(s => parseInt(s.codigo_postal) === (parseInt(props.cp))).length === 0) {
          return false;
        }
        return true;
      });
    }
  }, [items, props.cp])

  return (
    <>
      <SelectValidator
        value={listaLoc?.length > 0 ? props.valor || "" : ""}
        name={props.name}
        onChange={(e) => {
          props.manejadorInputChange(e);
        }}
        label="Localidad"
        disabled={props.disabled || !listaLoc.length}
        fullWidth={true}
        margin="normal"
        validators={!props.notRequired ? ['required', 'existCP'] : []}
        errorMessages={!props.notRequired ? ['Seleccione una localidad', 'El codigo postal es inexistente, por favor contacte al administrador del sistema'] : []}
      >
        {listaLoc.map((loc) => (
          <MenuItem key={loc.value} value={loc.value}>
            {loc.display}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
});
